import * as v from "valibot";

// request schema
// 扩容策略，非必须值,枚举

export const ScaleUpPolicySchema = v.picklist([
  "SCALE_UP_POLICY_LEAST_Priority",
  "SCALE_UP_POLICY_LEAST_WASTE",
  "SCALE_UP_POLICY_MOST_PODS",
  "SCALE_UP_POLICY_RANDOM",
]);
export type ScaleUpPolicy = v.InferOutput<typeof ScaleUpPolicySchema>;

export const ScaleUpSchema = v.object({
  Enabled: v.nullish(v.boolean()),
  ScaleUpPolicy: v.nullish(ScaleUpPolicySchema),
});
export type ScaleUp = v.InferOutput<typeof ScaleUpSchema>;

export const ScaleDownSchema = v.object({
  DaemonsetEvictionForEmptyNodes: v.nullish(v.boolean()),
  DaemonsetEvictionForOccupiedNodes: v.nullish(v.boolean()),
  DelayAfterAdd: v.nullish(v.number()),
  DelayAfterFailure: v.nullish(v.number()),
  Enabled: v.nullish(v.boolean()),
  GpuUtilizationThreshold: v.nullish(v.number()),
  MaxEmptyBulkDelete: v.nullish(v.number()),
  MaxGracefulTerminationSec: v.nullish(v.number()),
  MinReplicaCount: v.nullish(v.number()),
  SkipNodesWithLocalStorage: v.nullish(v.boolean()),
  SkipNodesWithSystemPods: v.nullish(v.boolean()),
  UnneededTime: v.nullish(v.number()),
  UtilizationThreshold: v.nullish(v.number()),
});
export type ScaleDown = v.InferOutput<typeof ScaleDownSchema>;

export const RequestSchema = v.object({
  ClusterId: v.string(),
  Id: v.string(),
  ScaleDown: v.nullish(ScaleDownSchema),
  ScaleUp: v.nullish(ScaleUpSchema),
  ScanInterval: v.nullish(v.number()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema

export const DataSchema = v.object({
  Id: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
